import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import './Layout.css';

const Layout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  // Esta función será pasada al componente Header
  const handleToggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };
  
  const mainContentClass = isMobile && sidebarExpanded 
    ? 'main-content content-pushed' 
    : 'main-content';
  
  return (
    <div className="layout-container">
      <Sidebar 
        expanded={sidebarExpanded} 
        onToggle={handleToggleSidebar} 
      />
      <div className={mainContentClass}>
        <Header onToggleSidebar={handleToggleSidebar} />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;